import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import classNames from 'classnames';
// Import JSX Modules
import DeliveryOptionOpenableMixin from './delivery-option-openable-mixin';
// Import JS Modules
import translate from '../_utils/tools/translate';

// -----------------------------------------------------------
//  SameDayPickupDeliveryOption
// -----------------------------------------------------------
const SameDayPickupDeliveryOption = createReactClass({
  mixins: [DeliveryOptionOpenableMixin],

  render() {
    return <div className={classNames('media delivery-box', { disabled: this.props.disabled })}
      onClick={this.clickAction}>
      <div className="media-left">
        <i className="far fa-clock"> </i>
      </div>
      <div className="media-body">
        <div className='row'>
          <div className='col-sm-12 col-6'>
            {this.props.title}
          </div>
          <div className='col-sm-12 col-6'>
            <span className="see-locations-message d-none d-sm-block">
              {this.props.disabled ? 'Unavailable' : 'See locations'}
              <span className={classNames('caret', { open: this.props.open })}></span>
            </span>
            <span className="see-locations-message d-block d-md-none text-right">
              {this.props.disabled ? 'Unavailable' : 'See locations'}
              <span className="chevron">&gt;</span>
            </span>
          </div>
        </div>
      </div>
    </div>;
  }
});

export default SameDayPickupDeliveryOption;
